import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvFeedback, AvForm, AvGroup} from 'availity-reactstrap-validation';
import AvField from '../../../shared/component/form/AvField';
import PropTypes from 'prop-types';
import Translate from "../../../shared/language/Translate";
import {INCIDENT_CONFIRMATION_STATUS} from "../../../shared/utils/Constants";
import Dialog from "../../../shared/component/dialog/Dialog";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import {toast} from "react-toastify";
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import RequestCommentService from "../../../shared/service/RequestCommentService";
import HsmResolutionCodeService from "../../../shared/service/HsmResolutionCodeService";
import HermesSweetAlert from "../../../shared/component/sweetAlert/HermesSweetAlert";

const data = {
    id: '',
    description: '',
    confirmationStatus: '1'
};

export default class CloseDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: data,
            pageMode: null,
            resolutionCode : null,
            resolutionShortCode : null,
            requestComment : null
        }
        this.hsmResolutionService = new HsmResolutionCodeService();
        this.requestCommentService = new RequestCommentService();
    }

/*
    componentDidMount = () => {
        setRequestCommentAndResolutionCode();
    }*/

    render() {
        return (

            <Row className="justify-content-center">
                <Col md="8">
                    <Dialog
                        header={'Kapatma Bilgileri'} modal={true} resizable={true} visible={this.state.displayDialog}
                        maximizable={true} responsive={true} onHide={() => {
                        this.setState({displayDialog: false});
                    }}
                        style={{width: '50vw'}}>

                        <AvForm onValidSubmit={this.close}>
                            <Toolbar display={true}>
                                <div className="p-toolbar-group-right">
                                    <Button color="primary" className="float-right" type="submit">
                                        Kaydet
                                    </Button>
                                    <Button color="primary" className="float-right"
                                            onClick={() => {
                                                this.setState({displayDialog: false});
                                            }}>
                                        Vazgeç
                                    </Button>
                                </div>
                            </Toolbar>

                            <AvGroup>
                                <Label for="resolutionShortCode">
                                    Çözüm Kodu
                                </Label>
                                <AvField type="text" className="form-control" name="resolutionShortCode"
                                         disabled
                                         value={this.state.resolutionShortCode}/>
                            </AvGroup>

                            <AvGroup>
                                <Label for="requestComment">
                                    Çözüm Açıklaması
                                </Label>
                                <AvField type="textarea"  className="form-control textAreaCloseDialog" name="requestComment"
                                         disabled
                                         value={GeneralUtils.isNullOrEmpty(this.state.requestComment) ? "" : this.state.requestComment}/>
                            </AvGroup>

                            <AvGroup>
                                <Label for="confirmationStatus">
                                    Müşteri Memnuniyeti
                                </Label>
                                <AvField type="select" className="form-control" name="confirmationStatus"
                                         validate={{
                                             required: {
                                                 value: true,
                                                 errorMessage: 'Bu alanın doldurulması zorunludur.'
                                             }
                                         }}
                                         value={this.state.data.confirmationStatus}
                                         onChange={this.__handleChange}>
                                    {INCIDENT_CONFIRMATION_STATUS.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>

                            <AvGroup>
                                <Label for="description">
                                    <Translate contentKey="description">Açıklama</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="textarea"
                                    className="form-control textAreaHermes"
                                    name="description"
                                    validate={{
                                        maxLength: {
                                            value: 4000,
                                            errorMessage: "Bu alana en fazla 4000 karakter girebilirsiniz."
                                        },
                                        required: {
                                            value: "true",
                                            errorMessage: "Bu alanın doldurulması zorunludur."
                                        }
                                    }}
                                    value={this.state.data.description}
                                    onChange={this.__handleChange}
                                />
                                <AvFeedback>Bu alana en fazla 4000 karakter girebilirsiniz.</AvFeedback>
                            </AvGroup>
                        </AvForm>
                    </Dialog>
                </Col>
            </Row>
        );
    }

    close = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.data.description)) {
            return toast.warn("Zorunlu Alan : Açıklama Giriniz!");
        }
        if(GeneralUtils.isNullOrEmpty(this.state.resolutionShortCode)){
            return HermesSweetAlert.error( <div dangerouslySetInnerHTML={{__html:"<p align='left'> Arıza kaydı için girilmiş <strong>“Çözüm Kodu” </strong> değerinde problem vardır. Lütfen durumu <strong>Sistem Yöneticisi’ </strong>ne iletiniz.</p>"+
                    "<p align='left'> <strong>Not: </strong> Eğer arızanız giderildi ise lütfen yeniden açmayınız. </p>"}}/>);
        }
        this.props.close();
        this.setState({displayDialog: false});
    }

    setData = (data) => {
        this.setState({data: data});
    }

    clearData = () => {
        this.setState({data: Object.assign({}, data)});
    }

    getData = () => {
        return this.state.data;
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let data = this.state.data;
        data[e.target.name] = value;
        this.setState({data: data});
    }

    setDialog = (value) => {
        this.clearData();
        this.setState({displayDialog: value});
    }

    setRequestCommentAndResolutionCode(requestType , requestId , resolutionCode ){
        /* this.state.resolutionCode= resolutionCode;*/
        if (!GeneralUtils.__isValueEmpty(resolutionCode)) {
            this.hsmResolutionService.findByCode(resolutionCode).then(response => this.setState({resolutionShortCode: response.shortName}));
        }else{
            toast.error("Çözüm Kodu: null");
        }
        this.requestCommentService.findResolvedRequestCommentsByRequestTypeAndRequestId(requestType, requestId).then(response => {
                let a = response;
                this.setState({requestComment: response});
            }
        );
    }
}

CloseDialog.propTypes = {
    data: PropTypes.object
};
